import { z } from 'zod';
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';

extendZodWithOpenApi(z);

// Important: If additional properties will be supported in the future, make sure to add additional authorization checks,
// e. g. in `device-api/functions/device.ts`.

export const rcpsPlayerPropertiesInput = z.object({
  name: z.string().min(1),
}).strict();

export type RcpsPlayerPropertiesInput = z.infer<typeof rcpsPlayerPropertiesInput>;
